import styled, { css } from 'styled-components';
import ontarioLogo from '../assets/ontario-logo.svg';

const TermsContainer = styled.div`
	background-color: #41444f;
	display: ${props => (props.smaller ? 'inline-block' : 'flex')};
	${props =>
		!props.smaller &&
		css`
			flex-direction: row;
			align-items: center;
			justify-content: center;
		`};
`;

const LogoContainer = styled.div`
	display: inline-block;
	float: ${props => (props.smaller ? 'left' : 'auto')};
	margin-left: ${props => (props.smaller ? '6px' : '24px')};
	margin-top: ${props => (props.smaller ? '12px' : '0')};
	margin-right: ${props => (props.smaller ? '6px' : '0')};
`;

const LogoImage = styled.img`
	width: ${props => (props.smaller ? '90px' : '120px')};
	height: ${props => (props.smaller ? '24px' : '48px')};
`;

const TermsText = styled.p`
	padding: ${props => (props.smaller ? '12px' : '24px')};
	padding-left: ${props => (props.smaller ? '12px' : '14px')};
	color: var(--bannerTermsConditionsColor);
	font: var(--bannerTermsConditionsFont);
`;

const OntarioTerms = ({ smaller, text }) => {
	return (
		<TermsContainer smaller={smaller}>
			<LogoContainer smaller={smaller}>
				<LogoImage smaller={smaller} src={ontarioLogo} />
			</LogoContainer>

			<TermsText smaller={smaller}>{text}</TermsText>
		</TermsContainer>
	);
};

export default OntarioTerms;
